import React from "react";

// Friendly 404 for unknown paths. The Vercel rewrite sends every
// non-asset URL to index.html, so the SPA must detect unknown routes
// itself and render this rather than silently showing the home page.
export function NotFoundPage(): React.ReactElement {
  return (
    <div
      dir="rtl"
      style={{
        minHeight: "100vh",
        background: "#FAF7F2",
        color: "#2D1B10",
        fontFamily: "'Heebo', system-ui, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 520,
          background: "#FFFDF9",
          border: "1px solid #E8DCC8",
          borderRadius: 16,
          padding: "32px 28px",
          boxShadow: "0 4px 24px rgba(92,61,46,0.10)",
          textAlign: "right",
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 8 }}>🧭</div>
        <h1
          style={{
            fontFamily: "'Frank Ruhl Libre', serif",
            fontSize: 28,
            fontWeight: 700,
            color: "#5C3D2E",
            marginBottom: 12,
          }}
        >
          הדף שחיפשתם לא נמצא
        </h1>
        <p style={{ fontSize: 15, lineHeight: 1.7, color: "#5C3D2E", marginBottom: 22 }}>
          ייתכן שהקישור שגוי או שהדף הוזז. אפשר לחזור לעמוד הראשי ולהתחיל
          משם, או לכתוב לנו אם הגעתם לכאן מקישור ששלחנו לכם.
        </p>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <a
            href="/"
            style={{
              background: "#5C3D2E",
              color: "white",
              borderRadius: 40,
              padding: "10px 22px",
              fontSize: 14,
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            לעמוד הראשי
          </a>
          <a
            href="mailto:shlomo@eiforall.com?subject=דף%20לא%20נמצא"
            style={{
              background: "#F3EDE3",
              color: "#5C3D2E",
              border: "1px solid #E8DCC8",
              borderRadius: 40,
              padding: "10px 22px",
              fontSize: 14,
              fontWeight: 500,
              textDecoration: "none",
            }}
          >
            כתבו לנו
          </a>
        </div>
      </div>
    </div>
  );
}
